import { useState, useEffect } from "react";

// "Extended" nav mode (the <> admin toggle): merges a page's nav toggles so all
// their options render inline on the same bar instead of opening dropdowns.
// Stored in localStorage + broadcast via a window event so any component (incl.
// the Layout header button and each page) can read/react without a shared
// provider scope.
const KEY = "rosterly_nav_extended";
const EVT = "rosterly-nav-extended";

export function getNavExtended() {
    try { return localStorage.getItem(KEY) !== "0"; } catch { return true; }
}

export function setNavExtended(v) {
    try { localStorage.setItem(KEY, v ? "1" : "0"); } catch { /* noop */ }
    try { window.dispatchEvent(new Event(EVT)); } catch { /* noop */ }
}

export function useNavExtended() {
    const [v, setV] = useState(getNavExtended);
    useEffect(() => {
        const h = () => setV(getNavExtended());
        window.addEventListener(EVT, h);
        return () => window.removeEventListener(EVT, h);
    }, []);
    return v;
}
